import { render, staticRenderFns } from "./CreateupdateUser.vue?vue&type=template&id=1ca95d6c&"
import script from "./CreateupdateUser.vue?vue&type=script&lang=js&"
export * from "./CreateupdateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports